export enum NotificationGroupType {
  Applicant = "applicant",
  Client = "client",
}

export enum WorkflowWebhookParameterType {
  String = "string",
  Numeric = "numeric",
  Boolean = "boolean",
}

export enum WorkflowWebhookParameterBooleanValue {
  True = "true",
  False = "false",
}

export enum WorkflowTemplateCategory {
  Marketplace = 1,
}

export enum WorkflowTemplateStatus {
  Draft = 0,
  Await = 1,
  Approval = 2,
  Decline = 3,
}
